function typeToImportance (item) {
  switch (item.definition.itemType) {
    case 3: // weapon
      return 1
    case 2: // armor
      return 2
    case 8:
      return 3
    case 9:
      return 4
    default:
      return 5
  }
}

function compare (a, b) {
  if (a !== b) {
    return a < b ? -1 : 1
  }
  return 0
}

export function itemCompare (a, b) {
  /* type */
  return compare(a.favorited ? 0 : 1, b.favorited ? 0 : 1) ||
    compare(typeToImportance(a), typeToImportance(b)) || // type
    compare(a.bucket.bucketOrder, b.bucket.bucketOrder) || // sub type
    byTierType(a, b) || // tier
    byName(a, b) ||
    byPowerLevel(a, b)
}

export function byTierType (a, b) {
  return compare(-a.tierType.index, -b.tierType.index)
}

export function byPowerLevel (a, b) {
  return 0
}

export function byName (a, b) {
  return compare(a.name, b.name)
}

export function byNameAndPowerLevel (a, b) {
  return byName(a, b) ||
    byPowerLevel(a, b)
}

export const orderings = {
  'Default': itemCompare,
  'By Power Level': byPowerLevel,
  'By Name': byNameAndPowerLevel
}



// WEBPACK FOOTER //
// ./src/utils/orderings.js